// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ──────────────────────────────────────────────────────────────────────────
   Reporting workspace — top-level layout.
   The whole workspace is a single white card (.content-wrapper) that hosts the
   two-pane editor (left rail + max-space editor). The studies list and patient
   details now live inside the left rail (see editor.css).
   ────────────────────────────────────────────────────────────────────────── */
.reporting-page-layout {
  height: 100%;
}
.content-layout {
  padding: 0.625rem;
  height: 100%;
}
.content-wrapper {
  background: #fff;
  height: calc(100vh - 5.5rem);
  border: 0.0625rem solid #E2E8F1;
  border-radius: 0.75rem;
  overflow: hidden;
}
.empty-state {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  height: 100%;
  text-align: center;
  padding: 2rem;
}
/* ──────────────────────────────────────────────────────────────────────────
   Focus mode — recover vertical space by hiding the global app header and
   tightening the surrounding padding. Body class is set by ReportingWorkspace.
   ────────────────────────────────────────────────────────────────────────── */
body.report-focus-mode .header-container {
  display: none !important;
}
.reporting-page-layout.focus-mode .content-layout {
  padding: 0.25rem;
}
.reporting-page-layout.focus-mode .content-wrapper {
  height: calc(100vh - 0.5rem);
  border-radius: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./pages/Reporting/styles/reporting-page.css"],"names":[],"mappings":"AAAA;;;;;+EAK+E;AAC/E;EACE,YAAY;AACd;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;AAClB;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;AAEA;;;+EAG+E;AAC/E;EACE,wBAAwB;AAC1B;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB","sourcesContent":["/* ──────────────────────────────────────────────────────────────────────────\r\n   Reporting workspace — top-level layout.\r\n   The whole workspace is a single white card (.content-wrapper) that hosts the\r\n   two-pane editor (left rail + max-space editor). The studies list and patient\r\n   details now live inside the left rail (see editor.css).\r\n   ────────────────────────────────────────────────────────────────────────── */\r\n.reporting-page-layout {\r\n  height: 100%;\r\n}\r\n\r\n.content-layout {\r\n  padding: 0.625rem;\r\n  height: 100%;\r\n}\r\n\r\n.content-wrapper {\r\n  background: #fff;\r\n  height: calc(100vh - 5.5rem);\r\n  border: 0.0625rem solid #E2E8F1;\r\n  border-radius: 0.75rem;\r\n  overflow: hidden;\r\n}\r\n\r\n.empty-state {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  text-align: center;\r\n  padding: 2rem;\r\n}\r\n\r\n/* ──────────────────────────────────────────────────────────────────────────\r\n   Focus mode — recover vertical space by hiding the global app header and\r\n   tightening the surrounding padding. Body class is set by ReportingWorkspace.\r\n   ────────────────────────────────────────────────────────────────────────── */\r\nbody.report-focus-mode .header-container {\r\n  display: none !important;\r\n}\r\n\r\n.reporting-page-layout.focus-mode .content-layout {\r\n  padding: 0.25rem;\r\n}\r\n\r\n.reporting-page-layout.focus-mode .content-wrapper {\r\n  height: calc(100vh - 0.5rem);\r\n  border-radius: 0.5rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
